import type { GhostContentAPIOptions } from 'src/common/interfaces';
import type { ApiReducerPathType } from '../interfaces/api/api';

export * from './two-factor-auth';

export const SwagStoreURL = 'https://store.tryhackme.com/';
export const BASE_URL_V2 = '/api/v2/';
export const MAIN_DOMAIN_URL = 'https://tryhackme.com';
export const BASE_GHOST_CONTENT_URL = 'https://blog.tryhackme.com/ghost/api/content/';
export const API_REDUCER_PATH: ApiReducerPathType = 'api';
export const THM_USER_ID_KEY = 'thm_user_id';

export enum RTKQueryTag {
  AllCompanies = 'AllCompanies',
  NetworkTemplates = 'NetworkTemplates',
  NetworkTemplateDiagram = 'NetworkTemplateDiagram',
  AssignmentDetails = 'AssignmentDetails',
  AWSCloudTrainingAccounts = 'AWSCloudTrainingAccounts',
  AWSCloudTrainingUsers = 'AWSCloudTrainingUsers',
  Badges = 'Badges',
  PersonalBadges = 'PersonalBadges',
  ReCapMe = 'ReCapMe',
  Recaps = 'Recaps',
  YourMaterialUploads = 'YourMaterialUploads',
  YourMaterialCustomInstances = 'YourMaterialCustomInstances',
  ContentEngineerMaterials = 'ContentEngineerMaterials',
  Company = 'Company',
  CompanyAssignments = 'CompanyAssignments',
  CompanyCertifications = 'CompanyCertifications',
  CertificationSeats = 'CertificationSeats',
  CompanyInstructors = 'CompanyInstructors',
  CompanyModules = 'CompanyModules',
  CompanyPaths = 'CompanyPaths',
  CompanySubscriber = 'CompanySubscriber',
  CompanySSODomains = 'CompanySSODomains',
  CompanyUserDetails = 'CompanyUserDetails',
  CertificationResults = 'CertificationResults',
  PathDetails = 'PathDetails',
  EmploymentJourneyProgress = 'EmploymentJourneyProgress',
  Experiments = 'Experiments',
  FeatureFlag = 'FeatureFlag',
  Glossary = 'Glossary',
  Hacktivities = 'Hacktivities',
  SkillsMatrix = 'SkillsMatrix',
  HacktivitiesAllRooms = 'HacktivitiesAllRooms',
  HacktivitiesAllSeries = 'HacktivitiesAllSeries',
  HacktivitiesPercentage = 'HacktivitiesPercentage',
  HacktivitiesSeriesDetail = 'HacktivitiesSeriesDetail',
  LearnHacktivities = 'LearnHacktivities',
  UserChallengeRoomsOverallProgress = 'UserChallengeRoomsOverallProgress',
  RecommendationRooms = 'RecommendationRooms',
  ManageRoomAccessMembers = 'ManageRoomAccessMembers',
  ManageUsers = 'ManageUsers',
  Networks = 'Networks',
  Notifications = 'Notifications',
  PublicPaths = 'PublicPaths',
  Room = 'Room',
  RecommendationRoomDetails = 'RecommendationRoomDetails',
  RunningInstances = 'RunningInstances',
  Scoreboard = 'Scoreboard',
  SingleCompany = 'SingleCompany',
  Submissions = 'Submissions',
  InfluencerCampaigns = 'InfluencerCampaigns',
  CurrentB2CSubscriptionBillingData = 'CurrentB2CSubscriptionBillingData',
  B2CSubscriptionUpgradeCostEstimation = 'B2CSubscriptionUpgradeCostEstimation',
  Task = 'Task',
  Tickets = 'Tickets',
  User = 'User',
  CddAccess = 'CddAccess',
  Reminders = 'Reminders',
  UserAssignments = 'UserAssignments',
  UserFeedback = 'UserFeedback',
  UserOccupation = 'UserOccupation',
  ManageRooms = 'ManageRooms',
  ManageCategories = 'ManageCategories',
  ManageRoomCategories = 'ManageRoomCategories',
  ManageRoomTags = 'ManageRoomTags',
  ManageRoomDetail = 'ManageRoomDetail',
  ManageRoomUsers = 'ManageRoomUsers',
  UserRooms = 'UserRooms',
  ManageUserWriteUps = 'ManageUserWriteUps',
  ManageRoomTasks = 'ManageRoomTasks',
  ManageRoomTaskMaterial = 'ManageRoomTaskMaterial',
  ManageRoomStatsScoreboard = 'ManageRoomStatsScoreboard',
  Tags = 'Tags',
  TagCategories = 'TagCategories',
  VpnServers = 'VpnServers',
  Workspace = 'Workspace',
  WorkspaceDiscovery = 'WorkspaceDiscovery',
  WorkspaceLeaderboard = 'WorkspaceLeaderboard',
  WorkspaceChallenges = 'WorkspaceChallenges',
  WorkspaceActivity = 'WorkspaceActivity',
  WorkspaceSocSimLeaderboard = 'WorkspaceSocSimLeaderboard',
  CloudAwsEnvDetails = 'CloudAwsEnvDetails',
  CloudAwsEnvCredentials = 'CloudAwsEnvCredentials',
  CloudAzureEnvCredentials = 'CloudAzureEnvCredentials',
  CloudAzureLabs = 'CloudAzureLabs',
  AzureTenantOnboardingCompanies = 'AzureTenantOnboardingCompanies',
  PathOutline = 'PathOutline',
  CompanyDisplayPaths = 'CompanyDisplayPaths',
  DashboardQuestionsChart = 'DashboardQuestionsChart',
  Roadmaps = 'Roadmaps',
  TutorMessages = 'TutorMessages',
  DashboardNotifications = 'DashboardNotifications',
  AzureLab = 'AzureLab',
  SOCSimLastIncidentId = 'SOCSimLastIncidentId',
  SOCSimAlerts = 'SOCSimAlerts',
  SOCSimAlertsInProgress = 'SOCSimAlertsInProgress',
  SOCSimAlertDetails = 'SOCSimAlertDetails',
  AiModels = 'AiModels',
  AiConfigs = 'AiConfigs',
  SOCSimPlaybooks = 'SOCSimPlaybooks',
  SOCSimPlaybookDetails = 'SOCSimPlaybookDetails',
  AzureLabs = 'AzureLabs',
  SocSimRun = 'SocSimRun',
  SocSimRunStats = 'SocSimRunStats',
  SocSimRunSummary = 'SocSimRunSummary',
  SocSimRunSummaryAlerts = 'SocSimRunSummaryAlerts',
  SocSimUserRuns = 'SocSimUserRuns',
  SocSimStats = 'SocSimStats',
  SocSimCaseReports = 'SocSimCaseReports',
  SocSimCaseReportDetails = 'SocSimCaseReportDetails',
  SocSimScenarios = 'SocSimScenarios',
  SocSimScenarioContent = 'SocSimScenarioContent',
  SocSimOnboardingSteps = 'SocSimOnboardingSteps',
  PathsCurrent = 'PathsCurrent',
  PathCurrent = 'PathCurrent',
  UserFriends = 'UserFriends',
  Teams = 'Teams',
  TeamMembers = 'TeamMembers',
  TeamInvitations = 'TeamInvitations',
  CertificationState = 'CertificationState',
  CertificationSectionState = 'CertificationSectionState',
  CertificationPurchase = 'CertificationPurchase',
  CertificationsPurchase = 'CertificationsPurchase',
  CertificationPreviousResults = 'CertificationPreviousResults',
  CertificationMultipleChoiceQuestions = 'CertificationMultipleChoiceQuestions',
  CertificationExams = 'CertificationExams',
  SocSimLeaderboard = 'SocSimLeaderboard',
  GetCertificate = 'GetCertificate',
  PathProgress = 'PathProgress',
  SocSimAlertRate = 'SocSimAlertRate',
  TeamAlertRate = 'TeamAlertRate',
  SocSimTeamStats = 'SocSimTeamStats',
  SocSimUserReports = 'SocSimUserReports',
  MaterialUploadStatus = 'MaterialUploadStatus',
  SocSimGuides = 'SocSimGuides',
  KothMachinePool = 'KothMachinePool',
  KothRecentGames = 'KothRecentGames',
  KothGame = 'KothGame',
  Challenges = 'Challenges',
  CategorizationRules = 'CategorizationRules',
  CategorizationSources = 'CategorizationSources',
  CategorizationRuleTitles = 'CategorizationRuleTitles',
  CategorizationContexts = 'CategorizationContexts',
  CategorizationCategories = 'CategorizationCategories',
  RoomNpsSubmitted = 'RoomNpsSubmitted',
  PostRoomCompletionFeedback = 'PostRoomCompletionFeedback',
  Module = 'Module',
  SOCSimTeamsPoints = 'SOCSimTeamsPoints',
  SOCSimTeamsRank = 'SOCSimTeamsRank',
  WorkspaceKPI = 'WorkspaceKPI',
  Campaigns = 'Campaigns',
  SocSimAlertTypes = 'SocSimAlertTypes',
  PathsCurrentModule = 'PathsCurrentModule',
  WeeklyMission = 'WeeklyMission',
  SocSimRunSummarySharedLinks = 'SocSimRunSummarySharedLinks',
  SocSimPublicRunSummary = 'SocSimPublicRunSummary',
  WorkspaceInviteTeammates = 'WorkspaceInviteTeammates',
  ModuleScoreboard = 'ModuleScoreboard',
  CTFLatestEvent = 'CTFLatestEvent',
  CTFEvents = 'CTFEvents',
  CTFEventDetails = 'CTFEventDetails',
  CTFTopics = 'CTFTopics',
  Leagues = 'Leagues',
  UserRoomScore = 'UserRoomScore',
  UserPathScore = 'UserPathScore',
  MitreTechniqueProgress = 'MitreTechniqueProgress',
  MitreAssignment = 'MitreAssignment',
  RoomBlueprintStatistics = 'RoomBlueprintStatistics',
  RoomBlueprintTopActivities = 'RoomBlueprintTopActivities',
  RoomBlueprintFlows = 'RoomBlueprintFlows',
  RoomBlueprintFlow = 'RoomBlueprintFlow',
  RoomBlueprintActivity = 'RoomBlueprintActivity',
  AssignmentScoreboard = 'AssignmentScoreboard',
  SocSimAssignment = 'SocSimAssignment',
  ThreatHuntingRun = 'ThreatHuntingRun',
  ThreatHuntingScenarios = 'ThreatHuntingScenarios',
  ThreatHuntingTactics = 'ThreatHuntingTactics',
  ThreatHuntingTechniques = 'ThreatHuntingTechniques',
  ThreatHuntingTimeline = 'ThreatHuntingTimeline',
  TtxScenario = 'TtxScenario',
  TtxRun = 'TtxRun',
  RoomVersions = 'RoomVersions',
  TtxRunsQuota = 'TtxRunsQuota',
  TtxRuns = 'TtxRuns',
  TtxRunInviteOptions = 'TtxRunInviteOptions',
  TtxEvaluationSharedLink = 'TtxEvaluationSharedLink',
  TtxEvaluationDetails = 'TtxEvaluationDetails',
  TtxPublicEvaluationDetails = 'TtxPublicEvaluationDetails',
  TtxCurrentPhase = 'TtxCurrentPhase',
  TtxCommonExercises = 'TtxCommonExercises',
  SkillsMatrixImage = 'SkillsMatrixImage',
  SkillsMatrixAssignment = 'SkillsMatrixAssignment',
  Subscriptions = 'Subscriptions',
  CombinedSubscriptionDetails = 'CombinedSubscriptionDetails',
  AdminModule = 'AdminModule',
  ThreatHuntingMitreAccuracy = 'ThreatHuntingMitreAccuracy',
  ThreatHuntingOverallEvaluation = 'ThreatHuntingOverallEvaluation',
  ThreatHuntingUserReports = 'ThreatHuntingUserReports',
  ThreatHuntingUserRuns = 'ThreatHuntingUserRuns',
  SOCSimAlertSummaryDetails = 'SOCSimAlertSummaryDetails',
  RecentUserRooms = 'RecentUserRooms',
  ThreatHuntingRunSummarySharedLinks = 'ThreatHuntingRunSummarySharedLinks',
  ThreatHuntingGuides = 'ThreatHuntingGuides',
  ThreatHuntingScenarioContent = 'ThreatHuntingScenarioContent',
  WeeklyLeagues = 'WeeklyLeagues',
  UserFollowers = 'UserFollowers',
  UserFollowees = 'UserFollowees',
  UserSuggestedFollowees = 'UserSuggestedFollowees',
  UserVouchers = 'UserVouchers',
  TicketingEvents = 'TicketingEvents',
  TtxHasRun = 'TtxHasRun',
  TtxAssistants = 'TtxAssistants',
  TtxOpenRouters = 'TtxOpenRouters',
  TtxStages = 'TtxStages',
  TtxPhases = 'TtxPhases',
  TtxTemplates = 'TtxTemplates',
  TtxProfiles = 'TtxProfiles',
  TtxStaticScenario = 'TtxStaticScenario',
  Referrals = 'Referrals',
  CompanySkillsProgression = 'CompanySkillsProgression',
  CompanySkills = 'CompanySkills',
  Rewards = 'Rewards',
}

export const GOOGLE_SITE_KEY = '6LdnORYTAAAAAD3XKUn8v29ONJnxgF87-OnLqYdv';
export const LOCAL_STORAGE_MANAGEMENT_DASHBOARD_NAVIGATION_STATE_ID = 'management-dashboard-navigation-state';

export const GhostContentOpts: GhostContentAPIOptions = {
  url: 'https://blog.tryhackme.com',
  key: 'a0ed05fe5ffc034e42ec78f0fb',
  version: 'v5.0',
};

export const HALF_MINUTE_IN_MS = 30_000;
export const ONE_MIN_IN_MS = 60_000;
export const ONE_DAY_IN_MS = 86_400_000; // 1000 * 60 * 60 * 24

export const INTERCOM_APP_ID = 'pgpbhph6';
export const INTERCOM_API_BASE = 'https://api-iam.intercom.io';

export const COPY_TEXT = 'Copy Link';
export const COPIED_TEXT = 'Copied!';
export const SOMETHING_WENT_WRONG = 'Something went wrong. Please try again.';

export const CHARGEBEE_SITE_ID = process.env.NODE_ENV === 'production' ? 'tryhackme' : 'tryhackme-test';
export const CHILI_PIPER_SUBDOMAIN = 'tryhackme';

export enum ChiliPiperRouterNames {
  B2B = 'b2b',
  AWS = 'aws',
  EDUCATION = 'edu',
}

export const SHOW_SPLIT_SCREEN = 'showSplitScreen';
export const TUTOR_SEEN_ROOMS = 'tutor_seen_rooms';
export const TUTOR_INTERACTED_WITH_TIMESTAMP = 'tutor_interacted_with_timestamp';
export const LOGIN_REFERRER = 'login_referrer';

export enum UserAnnualPricing {
  ANNUAL_PLAN_PRICE_USD = 126,
  ANNUAL_PLAN_PRICE_GBP = 108,
}

export enum ExperimentNames {
  ADD_PREMIUM_FREE_ROADMAP = 'addPremiumFreeRoadmap',
  ADD_PREMIUM_FREE_ROADMAP_V2 = 'addPremiumFreeRoadmapV2',
  TUTOR_SOFT_LAUNCH_V1 = 'tutorSoftLaunchV1',
  TUTOR_SOFT_LAUNCH_V2 = 'tutorSoftLaunchV2',
  COMBINE_START_MACHINE_ATTACKBOX_WIDGET = 'combineStartMachineAttackboxWidget',
}

export const AI_TUTOR_NAME = 'Echo';
export const DEFAULT_TUTOR_LANDING_PAGE_URL = `/${AI_TUTOR_NAME.toLowerCase()}`;
export const AI_TERMS_OF_USE_URL = '/legal/ai-terms-of-use';
export const TUTOR_STUCK_MESSAGE = "Hey, I'm stuck!";

export enum TutorEngagementPrompt {
  FIRST_TIME = "Welcome! I'm here to help you with real-time guidance, personalized hints, and explanations. 🚀",
  SUBSEQUENT = 'Welcome back! Need any assistance with your current task? I can help in this room as well. 🚀',
  DEFAULT = 'Stuck on a question? I am here to help you with real-time guidance, personalized hints, and explanations. 🚀',
}

export const EXPERIMENTS_CONFIG_COOKIE = 'thm-experiments-config';
